import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {
    orders: [],
    filterItems: {},
    countFilter: 0,
    order_total: 0,
    noMoreOrders: false
  },
  mutations: {
    SET_DATA(state, {orders, page}) {

      if (page > 1) {
        state.orders = state.orders.concat(orders.data.items)
      }
      else
        state.orders = orders.data.items;
      if (state.orders.length >= orders.data.total)
        state.noMoreOrders = true;
      state.filterItems = orders.data.filterItems;
      state.countFilter = orders.data.countFilter;
      state.loaded = true; // Устанавливаем флаг, что данные загружены
      state.section = orders.data.section;
      state.order_total = orders.data.total;
    },
  },
  actions: {
    async fetchOrders({ commit, state }, {page, sort, filter={}, search='', first=false, page_size=false, withoutpage= false}) {

      if (state.orders.length > 0 && first) {
        return;
      }


      if (page == 1) {
        commit('RESET_STATE');
        state.noMoreOrders = false;
      }

      let params = {
        page: page
      };
      if (filter)
        params.filter = filter;
      if (page_size)
        params.page_size = page_size;
      if (sort)
        params.sort = sort;
      if (filter) {
        params.filter = filter;
        params.set_filter = 'Y';
      }
      if (withoutpage)
        params.withoutpage = withoutpage;

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/order/', {
          params: params
        });
        if (response?.data?.data?.items) {
          commit('SET_DATA', {orders: response.data, page: page});
          commit('SET_ERROR', null);
        }
        else {
          if (response?.data?.errors && Array.isArray(response.data.errors)) {
            // Проверяем есть ли в массиве ошибки с числовым кодом или code_error
            const hasTechnicalError = response.data.errors.some(
                error => typeof error.code === 'number' || error.code === 'code_error'
            );

            if (hasTechnicalError) {
              commit('SET_ERROR', 'Техническая ошибка');
            } else {
              const errorMessages = response.data.errors
                  .map(error => error.message)
                  .join('. ');

              commit('SET_ERROR', errorMessages);
            }
          } else {
            commit('SET_ERROR', 'Произошла ошибка при выполнении операции');
          }


        }

      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    orders: state => state.orders,
    filterItems: state => state.filterItems,
    countFilter: state => state.countFilter,
    ordersLoading: state => state.loading,
    ordersError: state => state.error,
    ordersLoaded: state => state.loaded,
    order_total: state => state.order_total,
    section: state => state.section,
    section_id: state => state.section_id,
    noMoreOrders: state => state.noMoreOrders
  }
})